<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(1,0,0,1,-2559.66,0)">
      <g id="IntroScreen" transform="matrix(0.5,0,0,0.5,2559.66,0)">
        <rect x="0" y="0" width="2160" height="3840" style="fill: none" />
        <clipPath id="_clip1">
          <rect x="0" y="0" width="2160" height="3840" />
        </clipPath>
        <g clip-path="url(#_clip1)">
          <g
            id="Layer-1"
            serif:id="Layer 1"
            transform="matrix(1.00072,0,0,1.00072,0.56421,0.000723674)"
          >
            <g
              id="background.jpg"
              transform="matrix(1.99855,0,0,1.99855,-0.563802,-0.000723151)"
            >
              <image
                href="../assets/background.jpg"
                x="0"
                y="0"
                width="1080px"
                height="1920px"
              />
            </g>
            <g id="rules_container">
              <path
                :d="rulesContainerPath"
                style="
                  fill: white;
                  fill-rule: nonzero;
                  filter: url(#dropShadow);
                "
              />
              <text
                x="280"
                y="1275"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 500;
                  font-size: 104px;
                  fill: rgb(48, 48, 48);
                "
              >
                <tspan x="280" y="1275">Tik zo snel mogelijk op het rode</tspan>
                <tspan x="290" dy="1.35em">vlak om punten te scoren.</tspan>
                <tspan x="270" dy="1.35em">
                  Hoe sneller je de juiste vlakken
                </tspan>
                <tspan x="290" dy="1.35em">aantikt, hoe meer punten je</tspan>
                <tspan x="275" dy="1.35em">
                  verdient. Tik je op een geel vlak
                </tspan>
                <tspan x="290" dy="1.35em">dan verlies je punten.</tspan>
              </text>
            </g>
            <g id="StartBtn" @click="gotoGame">
              <g transform="matrix(1,0,0,1,1969.42,2536.78)">
                <rect
                  x="-1798.27"
                  y="0"
                  width="1815.002"
                  height="258.817"
                  rx="50"
                  ry="50"
                  style="
                    fill: rgb(145, 202, 238);
                    fill-rule: nonzero;
                    filter: url(#dropShadow);
                  "
                />
              </g>
              <g transform="matrix(1.00052,0,0,1.00052,-409.118,-1.36457)">
                <g transform="matrix(129.135,0,0,129.135,2143.2,2712.17)"></g>
                <text
                  x="720px"
                  y="2712.17px"
                  style="
                    font-family: 'Inter', 'Open Sans', sans-serif;
                    font-weight: 800;
                    font-size: 129.135px;
                    fill: rgb(22, 38, 78);
                  "
                >
                  Klaar om op te beginnen?
                </text>
              </g>
            </g>
            <g transform="matrix(1.00052,0,0,1.00052,-0.240262,-0.19218)">
              <g transform="matrix(221,0,0,221,1687.19,526.779)"></g>
              <text
                x="520px"
                y="526.779px"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 800;
                  font-size: 221px;
                  fill: rgb(254, 254, 254);
                "
              >
                Spelregels
              </text>
            </g>
          </g>
          <g id="Layer-2" serif:id="Layer 2"></g>
        </g>
      </g>
    </g>
    <defs>
      <filter id="dropShadow">
        <feOffset dx="0" dy="30" result="offsetblur" />
        <feGaussianBlur in="offsetblur" stdDeviation="6" result="outputblur" />
        <feFlood flood-color="rgba(0,0,0,0.2)" result="offsetblur" />
        <feComposite
          in="offsetblur"
          in2="outputblur"
          operator="in"
          result="offsetblur"
        />
        <feMerge>
          <feMergeNode in="offsetblur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "StartScreen",
  data() {
    return {
      rulesContainerX: 164.499,
      rulesContainerY: 1100,
      rulesContainerWidth: 1815.002,
      rulesContainerHeight: 1000,
      rulesContainerCornerRadius: 200,
    };
  },
  created() {
    // reset score
    this.$store.commit("setScore", 0);
  },
  computed: {
    loading() {
      return this.$store.getters.getLoading;
    },
    rulesContainerPath() {
      const x = this.rulesContainerX;
      const y = this.rulesContainerY;
      const width = this.rulesContainerWidth;
      const height = this.rulesContainerHeight;
      const maxRadius = Math.min(width, height);
      const radius = Math.max(
        0,
        Math.min(this.rulesContainerCornerRadius, maxRadius)
      );
      const right = x + width;
      const bottom = y + height;
      return [
        `M${x},${y}`,
        `L${right},${y}`,
        `L${right},${bottom - radius}`,
        `C${right},${bottom - radius + radius * 0.523} ${
          right - radius + radius * 0.5523
        },${bottom} ${right - radius},${bottom}`,
        `L${x},${bottom}`,
        `L${x},${y}Z`,
      ].join("");
    },
  },
  methods: {
    gotoGame() {
      this.$store.commit("setPlayerState", "game");
    },
  },
};
</script>
